module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modules/stat/stat.component.scss
// module id = ./src/app/shared/modules/stat/stat.component.scss
// module chunks = main